import { createFileRoute, redirect } from "@tanstack/react-router"

/** Bookmarks to the old company-wide inbox land on Jobs (counts → job detail). */
export const Route = createFileRoute("/recruit/applicants")({
  beforeLoad: () => {
    throw redirect({ to: "/recruit/jobs" })
  },
  component: () => null,
})
